export default __webpack_public_path__ + "static/media/anguriaTtsIt_It60.2f504325.mp3";